import { ReactNode, useState } from 'react';

import { Button } from '@/design-system/components/Button';

interface ExpandableTextProps {
  text: string;
  initialMaxLength?: number;
  incrementLength?: number;
  renderContent?: (maxLength: number) => ReactNode;
}

export const ExpandableText = ({
  text,
  initialMaxLength = 5000,
  incrementLength = 5000,
  renderContent,
}: ExpandableTextProps) => {
  const [currentMaxLength, setCurrentMaxLength] = useState(initialMaxLength);

  if (text.length <= currentMaxLength) {
    return renderContent ? renderContent(text.length) : text;
  }

  const handleShowMore = () => {
    setCurrentMaxLength(currentMaxLength + incrementLength);
  };

  return (
    <>
      {renderContent ? (
        renderContent(currentMaxLength)
      ) : (
        <>
          {text.slice(0, currentMaxLength)}
          <span className="text-gray-500">...</span>
        </>
      )}
      <Button
        onClick={handleShowMore}
        variant="underlined"
        color="secondary"
        size="sm"
        className="mb-1 block self-start"
      >
        Show more
      </Button>
    </>
  );
};
